/**
 * TruEats Header JS
 * Handles: nav toggle, announcement close, cart count, scroll transparency.
 * Vanilla JS only — no jQuery dependency. Safe alongside Vintage theme JS.
 * File: assets/trueats-header.js  |  Status: NEW
 */
(function () {
  'use strict';

  /* -------------------------------------------------------------------------
     Mobile nav toggle
  ------------------------------------------------------------------------- */
  function initNavToggle() {
    var toggle = document.querySelector('[data-trueats-nav-toggle]');
    var nav    = document.querySelector('[data-trueats-primary-nav]');
    console.log(toggle);
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var isOpen = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', isOpen ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    // Close nav when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-trueats-header]')) {
        nav.setAttribute('data-open', 'false');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Close nav on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        nav.setAttribute('data-open', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* -------------------------------------------------------------------------
     Mobile dropdown toggle (child links inside mobile nav)
  ------------------------------------------------------------------------- */
  function initMobileDropdowns() {
    var dropdownParents = document.querySelectorAll(
      '.trueats-header__nav-item--has-dropdown'
    );
    if (!dropdownParents.length) return;

    dropdownParents.forEach(function (item) {
      var link = item.querySelector('.trueats-header__nav-link');
      if (!link) return;
      link.addEventListener('click', function (e) {
        // Only intercept on mobile
        if (window.innerWidth > 900) return;
        e.preventDefault();
        item.classList.toggle('is-open');
      });
    });
  }

  /* -------------------------------------------------------------------------
     Announcement bar dismissal (persisted to sessionStorage)
  ------------------------------------------------------------------------- */
  function initAnnouncementBar() {
    var bar   = document.querySelector('[data-trueats-announcement]');
    var close = document.querySelector('[data-trueats-announcement-close]');
    if (!bar || !close) return;

    // Respect previous dismissal within same session
    if (sessionStorage.getItem('trueats-announcement-dismissed') === '1') {
      bar.hidden = true;
      return;
    }

    close.addEventListener('click', function () {
      bar.hidden = true;
      sessionStorage.setItem('trueats-announcement-dismissed', '1');
    });
  }

  /* -------------------------------------------------------------------------
     Cart count badge visibility
  ------------------------------------------------------------------------- */
  function initCartCount() {
    var badge = document.querySelector('[data-trueats-cart-count]');
    if (!badge) return;

    function updateBadge(count) {
      var n = parseInt(count, 10) || 0;
      badge.textContent = n;
      badge.classList.toggle('is-visible', n > 0);
    }

    // Initial state from server-rendered value
    updateBadge(badge.textContent);

    // Listen for Shopify AJAX cart updates (works with most AJAX cart apps)
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && typeof e.detail.itemCount !== 'undefined') {
        updateBadge(e.detail.itemCount);
      }
    });

    // Also listen for native Shopify sections:load which some apps trigger
    document.addEventListener('shopify:section:load', function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (data) { updateBadge(data.item_count); })
        .catch(function () {});
    });
  }

  /* -------------------------------------------------------------------------
     Scroll transparency: add/remove .is-scrolled on the header element
     so the sticky header gets a solid bg only after the user starts scrolling
  ------------------------------------------------------------------------- */
  function initScrollTransparency() {
    var header = document.querySelector('[data-trueats-header]');
    if (!header) return;

    var heroExists = document.querySelector('[data-trueats-hero]');
    // Only activate transparency effect when a hero section is present
    if (!heroExists) return;

    header.classList.add('is-transparent');

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          if (window.scrollY > 60) {
            header.classList.remove('is-transparent');
            header.classList.add('is-scrolled');
          } else {
            header.classList.add('is-transparent');
            header.classList.remove('is-scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  }

  /* -------------------------------------------------------------------------
     Boot
  ------------------------------------------------------------------------- */
  function init() {
    console.log('called');
    initNavToggle();
    initMobileDropdowns();
    initAnnouncementBar();
    initCartCount();
    initScrollTransparency();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
